
import { BarChart3, Activity } from "lucide-react";

export const AnalyticsHeader = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-center gap-4 sm:gap-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 via-indigo-500 to-purple-500 bg-clip-text text-transparent">
          Analytics Dashboard
        </h1>
        <div className="flex-shrink-0">
          <BarChart3 className="h-8 w-8 text-blue-600" />
        </div>
      </div>
      
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
        <div className="flex items-center justify-center gap-2">
          <Activity className="h-5 w-5 text-blue-600" />
          <p className="text-blue-800 text-center font-medium text-lg">
            Live bezoekersstatistieken en zoekanalyses
          </p>
        </div>
      </div>
    </div>
  );
};
